export enum WorkflowAction {
    None = 'None',
    SubmitReview = 'Send for review',
    SendBack = 'Send back',
    Approve = 'Approve'
}